import { useState }
    from "react";

import {
    CheckCircle2,
    AlertCircle,
    Loader2,
} from "lucide-react";

import {
    createBooking
} from "../../services/bookingService";

import { useAuth }
    from "../../context/AuthContext";

import { useCart }
    from "../../context/CartContext";

function CartSummary({

    total,

    onClear,

    items,
}) {

    const {
        currentUser
    } = useAuth();

    const {
        clearCart
    } = useCart();

    const [loading, setLoading]
        = useState(false);

    const [notification, setNotification]
        = useState(null);

    /* ---------------------------------- */
    /* TOTALS */
    /* ---------------------------------- */

    const tax =
        total * 0.1;

    const serviceFee = 5;

    const grandTotal =
        total + tax + serviceFee;

    /* ---------------------------------- */
    /* NOTIFY */
    /* ---------------------------------- */

    const notify = (

        message,

        success = true

    ) => {

        setNotification({

            message,

            success,
        });

        setTimeout(() => {

            setNotification(null);

        }, 3500);
    };

    /* ---------------------------------- */
    /* CHECKOUT */
    /* ---------------------------------- */

    const handleCheckout =
        async () => {

            /* EMPTY */

            if (!items?.length) {

                notify(
                    "Cart is empty",
                    false
                );

                return;
            }

            /* LOGIN */

            if (!currentUser) {

                notify(
                    "Please login first",
                    false
                );

                return;
            }

            try {

                setLoading(true);

                const result =

                    await createBooking({

                        user: {

                            uid:
                                currentUser.uid,

                            email:
                                currentUser.email,

                            name:
                                currentUser.displayName || "",
                        },

                        cartItems:
                            items,
                    });

                console.log(
                    "Booking success:",
                    result
                );

                clearCart();

                notify(
                    "Booking confirmed!"
                );

            } catch (error) {

                console.error(error);

                notify(

                    error.message
                    ||
                    "Booking failed",

                    false
                );

            } finally {

                setLoading(false);
            }
        };

    return (

        <div style={styles.card}>

            {/* NOTIFICATION */}

            {notification && (

                <div

                    style={{

                        ...styles.notification,

                        borderColor:
                            notification.success

                                ? "rgba(0,255,136,0.35)"

                                : "rgba(255,107,107,0.35)",
                    }}
                >

                    <div style={styles.notificationContent}>

                        {notification.success ? (

                            <CheckCircle2
                                size={18}
                                color="#00ff88"
                            />

                        ) : (

                            <AlertCircle
                                size={18}
                                color="#ff6b6b"
                            />
                        )}

                        <span
                            style={{

                                color:
                                    notification.success

                                        ? "#00ff88"

                                        : "#ff8a8a",
                            }}
                        >

                            {
                                notification.message
                            }

                        </span>

                    </div>

                </div>
            )}

            <h2 style={styles.title}>
                Order Summary
            </h2>

            <div style={styles.row}>
                <span>Subtotal</span>
                <span>${total}</span>
            </div>

            <div style={styles.row}>
                <span>Service Fee</span>
                <span>${serviceFee}</span>
            </div>

            <div style={styles.row}>
                <span>Tax</span>
                <span>
                    ${tax.toFixed(2)}
                </span>
            </div>

            <div style={styles.divider}></div>

            <div style={styles.totalRow}>
                <span>Total</span>

                <span style={styles.totalPrice}>
                    ${grandTotal.toFixed(2)}
                </span>
            </div>

            {/* CHECKOUT */}

            <button

                style={{

                    ...styles.checkout,

                    opacity:
                        loading
                            ? 0.7
                            : 1,

                    cursor:
                        loading
                            ? "not-allowed"
                            : "pointer",
                }}

                onClick={
                    handleCheckout
                }

                disabled={
                    loading
                }
            >

                <div style={styles.buttonContent}>

                    {loading && (

                        <Loader2
                            size={18}
                            className="spin"
                        />
                    )}

                    <span>

                        {loading

                            ? "Processing..."

                            : "Confirm Booking"
                        }

                    </span>

                </div>

            </button>

            {/* CLEAR */}

            <button
                style={styles.clear}
                onClick={onClear}

                disabled={loading}
            >
                Clear Cart
            </button>

        </div>
    );
}

const styles = {

    card: {

        position: "sticky",

        top: "120px",

        background:
            "rgba(0,40,70,0.72)",

        backdropFilter:
            "blur(12px)",

        borderRadius:
            "24px",

        padding:
            "28px",

        border:
            "1px solid rgba(0,255,150,0.15)",

        boxShadow:
            "0 10px 40px rgba(0,0,0,0.25)",

        overflow:
            "hidden",
    },

    notification: {

        marginBottom:
            "20px",

        padding:
            "14px",

        borderRadius:
            "14px",

        background:
            "rgba(255,255,255,0.04)",

        border:
            "1px solid",
    },

    notificationContent: {

        display:
            "flex",

        alignItems:
            "center",

        gap:
            "10px",

        fontSize:
            "14px",

        fontWeight:
            "600",
    },

    title: {

        color:
            "#fff",

        marginBottom:
            "28px",

        fontSize:
            "24px",

        fontWeight:
            "700",
    },

    row: {

        display:
            "flex",

        justifyContent:
            "space-between",

        color:
            "#d1d5db",

        marginBottom:
            "14px",

        fontSize:
            "15px",
    },

    divider: {

        height:
            "1px",

        background:
            "rgba(255,255,255,0.1)",

        margin:
            "22px 0",
    },

    totalRow: {

        display:
            "flex",

        justifyContent:
            "space-between",

        alignItems:
            "center",

        marginBottom:
            "28px",

        color:
            "#fff",

        fontWeight:
            "700",
    },

    totalPrice: {

        color:
            "#00ff88",

        fontSize:
            "28px",

        fontWeight:
            "800",
    },

    checkout: {

        width:
            "100%",

        padding:
            "16px",

        borderRadius:
            "16px",

        border:
            "none",

        background:
            "linear-gradient(90deg, #00ff88, #00d4ff)",

        color:
            "#041018",

        fontWeight:
            "700",

        transition:
            "all 0.2s ease",

        marginBottom:
            "14px",

        fontSize:
            "15px",
    },

    buttonContent: {

        display:
            "flex",

        alignItems:
            "center",

        justifyContent:
            "center",

        gap:
            "10px",
    },

    clear: {

        width:
            "100%",

        padding:
            "16px",

        borderRadius:
            "16px",

        border:
            "1px solid rgba(255,255,255,0.15)",

        background:
            "rgba(255,255,255,0.04)",

        color:
            "#fff",

        cursor:
            "pointer",

        fontWeight:
            "600",
    },
};

export default CartSummary;